import Vue from 'vue'
import get from 'lodash/get'

Vue.filter('get', (v: object, path: string, defaultValue: any = undefined) => {
  return get(v, path, defaultValue)
})
